import { render, staticRenderFns } from "./SliceCarousel.vue?vue&type=template&id=d6d5030c&lang=pug&"
import script from "./SliceCarousel.vue?vue&type=script&lang=js&"
export * from "./SliceCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports